export default __webpack_public_path__ + "static/media/img_case_03.1dd23728.jpg";